<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="12" md="2" class="pt-2" v-if="name">{{ name }}</b-col>

            <b-col cols="12" md="2">
              <b-button
                class="buttonlink"
                @click="changeList('basicinfo')"
                variant="link"
                style="color: black"
              >
                <b>Basic Info</b>
              </b-button>
              <b-progress
                height="2px"
                :value="listType == 'basicinfo' ? 50 : 0"
                class="pl-2"
              ></b-progress>
            </b-col>
            <b-col cols="12" md="2">
              <b-button
                class="buttonlink"
                @click="changeList('roles')"
                variant="link"
                style="color: black"
              >
                <b>Role & Rights</b>
              </b-button>
              <b-progress
                height="2px"
                :value="listType == 'roles' ? 70 : 0"
                class="pl-2"
              ></b-progress>
            </b-col>
            <b-col cols="12" md="2">
              <b-button
                class="buttonlink"
                @click="changeList('pending')"
                variant="link"
                style="color: black"
              >
                <b>Pending Actions</b>
              </b-button>
              <b-progress
                height="2px"
                :value="listType == 'pending' ? 83 : 0"
                class="pl-2"
              ></b-progress>
            </b-col>
            <b-col cols="12" md="2">
              <b-button
                class="buttonlink"
                @click="changeList('log')"
                variant="link"
                style="color: black"
              >
                <b>Activity Log</b>
              </b-button>
              <b-progress
                height="2px"
                :value="listType == 'log' ? 62 : 0"
                class="pl-2"
              ></b-progress>
            </b-col>
            <b-col cols="12" md="1">
              <b-dropdown
                size="md"
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <i
                    class="fa fa-ellipsis-v"
                    style="color: black"
                    aria-hidden="true"
                  ></i>
                </template>
                <b-dropdown-item
                  @click="showReason = !showReason"
                  v-b-modal.modal-lg
                  >Remove Admin</b-dropdown-item
                >

                <b-modal
                  v-model="showReason"
                  title="Admin Removal Confirmation"
                  centered
                  size="lg"
                >
                  <b-container fluid>
                    <b-row class="justify-content-md-center">
                      <b-col cols="12" md="8">
                        <b-form-group label="Reason for removal">
                          <b-form-textarea
                            id="textarea"
                            v-model="textReason"
                            placeholder
                            rows="3"
                            max-rows="6"
                          ></b-form-textarea>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-container>

                  <template v-slot:modal-footer>
                    <b-row>
                      <b-col cols="12" md="6">
                        <b-button
                          variant="light"
                          size="sm"
                          float-right
                          @click="show = false"
                          >Cancel</b-button
                        >
                      </b-col>
                      <b-col cols="12" md="2">
                        <b-button
                          variant="primary"
                          size="sm"
                          float-left
                          @click.prevent="removeAdmin"
                          >Remove</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>
                </b-modal>
              </b-dropdown>
            </b-col>
            <!-- <b-col cols="2" md="2">
              <b-button variant="link"  @click="previous()">  <i
                  v-if="previousIcon"
                  class="fa fa-chevron-left pr-4"
                  style="color: blue"
                
                  aria-hidden="true"
                ></i></b-button>
              <b-button variant="link" @click="next()">  <i
                  v-if="nextIcon"
                  class="fa fa-chevron-right"
                  style="color: blue"
                  @click="next()"
                  aria-hidden="true"
                ></i></b-button>
                </b-col> -->
          </b-row>
        </template>

        <div v-if="user && bascinfo">
          <b-row>
            <b-col v-if="user.photo" cols="12" class="py-2 text-center">
              <img :src="baseURL + '/u/' + user.photo" height="100px" />
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="10">
              <b-row>
                <b-col cols="12" md="6">
                  <b-row>
                    <b-col cols="12" md="5">
                      <span>Username *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.username"
                          type="text"
                          id="username"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <!-- <b-col cols="12" md="5">
                      <span>Password *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          v-model="password"
                          type="text"
                          id="password"
                          placeholder="Password"
                        ></b-form-input>
                      </b-form-group>
                    </b-col> -->

                    <b-col cols="12" md="5">
                      <span>Name *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.name"
                          type="text"
                          id="name"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="5">
                      <span>Gender *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.gender"
                          type="text"
                          id="gender"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="5">
                      <span>Email *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.email"
                          type="text"
                          id="email"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="5">
                      <span>Phone Number *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.phone"
                          type="text"
                          id="phone"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="5">
                      <span>Nationality *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          v-model="user.nationality"
                          disabled
                          type="text"
                          id="nationality"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col cols="12" md="6">
                  <b-row>
                    <b-col cols="12" md="5">
                      <span>Date of birth *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.dob"
                          type="text"
                          id="date"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="5">
                      <span>Photo ID *</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.photoid"
                          type="text"
                          id="photoid"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" md="5">
                      <span></span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <!-- <b-form-file id="file-small" size="sm"></b-form-file> -->
                    </b-col>

                    <b-col cols="12" md="5" class="pt-3">
                      <span>Occupation</span>
                    </b-col>
                    <b-col cols="12" md="7" class="pt-3">
                      <b-form-group>
                        <b-form-input
                          disabled
                          v-model="user.occupation"
                          type="text"
                          id="occupation"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col cols="12" md="5">
                      <span>Postal Address</span>
                    </b-col>
                    <b-col cols="12" md="7">
                      <b-form-group>
                        <b-form-textarea
                          id="textarea"
                          disabled
                          v-model="user.address"
                          rows="5"
                          max-rows="5"
                        ></b-form-textarea>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- <b-row v-if="superAdmin" class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="editUser">Edit</b-button>
            </div>
            <div class="px-2">
              <b-button
                v-if="userStatus=='Active'"
                variant="outline-danger"
                @click="confirmDeactivateUser"
                size="sm"
              >Deactivate User</b-button>
              <b-button
                v-if="userStatus=='Banned'"
                variant="outline-primary"
                @click="confirmDeactivateUser"
                size="sm"
              >Activate User</b-button>
            </div>
            <div class="px-2">
              <b-button variant="danger" size="sm" @click.prevent="confirmRemoveUser">Remove User</b-button>
            </div>
          </b-row> -->
        </div>

        <div v-else-if="rrights">
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12" md="12">
                  <!-- <div :class="{error: validation.hasError('role')}"> -->
                  <b-form-group label="Role *">
                    <b-form-select
                      v-model="role"
                      :options="roles"
                      disabled
                    ></b-form-select>
                    <!-- <template slot="description" v-if="validation.firstError('role')">
                        <span style="color:red;">{{validation.firstError('role')}}</span>
                    </template>-->
                  </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="12">
                  <b-row class="pt-4">
                    <b-col cols="6">
                      <span class="item_title mt-2">Action</span>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <span class="item_title">Can Perform</span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="6">
                      <span class="item_value mt-2">Remove Case</span>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-1"
                          disabled
                          v-model="userRights.removecase"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="6">
                      <span class="item_value mt-2">Remove Comment</span>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-2"
                          disabled
                          v-model="userRights.removecomment"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="6">
                      <span class="item_value mt-2">Ban User</span>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-3"
                          disabled
                          v-model="userRights.banuser"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="6">
                      <span class="item_value mt-2">Add Admins</span>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-4"
                          disabled
                          v-model="userRights.addloweradmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>

                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove Super Admins</span>
                      <!-- <br />
                      <span class="item_value" style="font-size: 12px"
                        >Need consensus of majority of super admins</span
                      > -->
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-5"
                          disabled
                          v-model="userRights.removesuperadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove Country Admins</span>
                      <!-- <br />
                      <span class="item_value" style="font-size: 12px"
                        >Need consensus of majority of super admins</span
                      > -->
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-5"
                          disabled
                          v-model="userRights.removecountryadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>

                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove State Admins</span>
                      <!-- <br />
                      <span class="item_value" style="font-size: 12px"
                        >Need consensus of majority of super admins</span
                      > -->
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-5"
                          disabled
                          v-model="userRights.removestateadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>

                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="9">
                      <span class="item_value mt-2">Remove City Admins</span>
                      <!-- <br />
                      <span class="item_value" style="font-size: 12px"
                        >Need consensus of majority of super admins</span
                      > -->
                    </b-col>
                    <b-col cols="3" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-5"
                          disabled
                          v-model="userRights.removecityadmin"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>

                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="8">
                      <span class="item_value mt-2"
                        >View activity log of lower admins</span
                      >
                    </b-col>
                    <b-col cols="4" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-7"
                          disabled
                          v-model="userRights.viewactivitylog"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="8">
                      <span class="item_value mt-2"
                        >View pending actions of lower admins</span
                      >
                    </b-col>
                    <b-col cols="4" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-6"
                          disabled
                          v-model="userRights.viewpendingaction"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <!-- <hr /> -->
                </b-col>
                <!-- <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="8">
                      <span class="item_value mt-2"
                        >Revert actions of Country admins</span
                      >
                    </b-col>
                    <b-col cols="4" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-8"
                          disabled
                          v-model="userRights.revertcountryadminaction"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                  <hr />
                </b-col>
                <b-col cols="12" md="12">
                  <b-row>
                    <b-col cols="8">
                      <span class="item_value mt-2"
                        >Revert actions of State admins</span
                      >
                    </b-col>
                    <b-col cols="4" class="text-right">
                      <span class="item_title">
                        <b-form-checkbox
                          id="checkbox-9"
                          disabled
                          v-model="userRights.revertstateadminaction"
                          name="checkbox-1"
                          color="#2BA09F"
                        ></b-form-checkbox>
                      </span>
                    </b-col>
                  </b-row>
                </b-col> -->
              </b-row>
            </b-col>
          </b-row>
        </div>

        <div v-else-if="pendingact || actlog">
          <b-row class="justify-content-md-center">
            <b-col cols="12" xl="12">
              <transition name="slide">
                <b-card>
                  <!-- <div slot="header">Tree Cut Reportings</div> -->
                  <template slot="header">
                    <b-row>
                      <b-col cols="12" md="4" class="py-1">
                        <span v-if="pendingact"><b>Pending Actions</b></span>
                        <span v-if="actlog"><b>Activity Log</b></span>
                      </b-col>
                    </b-row>
                  </template>
                  <b-table
                    v-if="isroot == 'true'"
                    :hover="true"
                    :striped="false"
                    :bordered="false"
                    :small="false"
                    :fixed="false"
                    responsive="sm"
                    :items="pendingact ? pendingactions : activitylogs"
                    :fields="pendingact ? fields : rootlogfields"
                  >
                    <template slot="action" slot-scope="data">
                      <div>
                        <span v-if="data.item.action">{{
                          data.item.action
                        }}</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                    <template slot="details" slot-scope="data">
                      <div class="text-center">
                        <span v-if="data.item.description">{{
                          data.item.description
                        }}</span>
                      </div>
                    </template>

                    <template slot="pending" slot-scope="data">
                      <div class="text-center">
                        <span
                          v-if="data.item.createddate"
                          :key="data.item.createddate"
                          >{{ formatDate(data.item.createddate) }}</span
                        >
                        <span v-else>-</span>
                      </div>
                    </template>

                    <template slot="addedby" slot-scope="data">
                      <div class="text-left">
                        <span v-if="data.item.addedby.name">{{
                          data.item.addedby.name
                        }}</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                    <template slot="createddate" slot-scope="data">
                      <div class="text-center">
                        <span v-if="data.item.createddate">{{
                          formatDate(data.item.createddate)
                        }}</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                    <template slot="revert" slot-scope="data">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="confirmrevertAction(data.item)"
                        >Revert</b-button
                      >
                    </template>
                  </b-table>
                  <b-table
                    v-else
                    :hover="true"
                    :striped="false"
                    :bordered="false"
                    :small="false"
                    :fixed="false"
                    responsive="sm"
                    :items="pendingact ? pendingactions : activitylogs"
                    :fields="pendingact ? fields : logfields"
                  >
                    <template slot="action" slot-scope="data">
                      <div>
                        <span v-if="data.item.action">{{
                          data.item.action
                        }}</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                    <template slot="details" slot-scope="data">
                      <div class="text-center">
                        <span v-if="data.item.description">{{
                          data.item.description
                        }}</span>
                      </div>
                    </template>

                    <template slot="pending" slot-scope="data">
                      <div class="text-center">
                        <span
                          v-if="data.item.createddate"
                          :key="data.item.createddate"
                          >{{ formatDate(data.item.createddate) }}</span
                        >
                        <span v-else>-</span>
                      </div>
                    </template>

                    <template slot="addedby" slot-scope="data">
                      <div class="text-left">
                        <span v-if="data.item.addedby.name">{{
                          data.item.addedby.name
                        }}</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                    <template slot="createddate" slot-scope="data">
                      <div class="text-center">
                        <span v-if="data.item.createddate">{{
                          formatDate(data.item.createddate)
                        }}</span>
                        <span v-else>-</span>
                      </div>
                    </template>
                    <template slot="revert" slot-scope="data">
                      <b-button
                        variant="outline-primary"
                        size="sm"
                        @click="confirmrevertAction(data.item)"
                        >Revert</b-button
                      >
                    </template>
                  </b-table>
                  <nav>
                    <b-pagination
                      v-if="pendingact"
                      size="sm"
                      :total-rows="totalpendingactions"
                      :per-page="perPage"
                      v-model="currentpendingactions"
                      prev-text="Prev"
                      next-text="Next"
                      @change="nextpending"
                    />
                    <b-pagination
                      v-else
                      size="sm"
                      :total-rows="totalactivitylogs"
                      :per-page="perPage"
                      v-model="currentactivitylogs"
                      prev-text="Prev"
                      next-text="Next"
                      @change="nextlog"
                    />
                  </nav>
                </b-card>
              </transition>
            </b-col>
          </b-row>
        </div>

        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
export default {
  props: {
    caption: {
      type: String,
      default: "User id",
      AppHeaderDropdown,
    },
  },
  data() {
    return {
      user: null,
      name: null,
      previousIcon: true,
      nextIcon: true,
      appLoading: false,
      ServerError: false,
      userRights: [],
      superAdmin: false,
      listType: "basicinfo",
      bascinfo: true,
      rrights: false,
      pendingact: false,
      actlog: false,
      showReason: false,
      textReason: null,
      roles: [
        { text: "Super Admin", value: "Admin" },
        { text: "Country Admin", value: "CountryAdmin" },
        { text: "State Admin", value: "StateAdmin" },
        { text: "City Admin", value: "CityAdmin" },
      ],
      countryselect: null,
      countrylist: [],
      removecase: false,
      removecomment: false,
      banuser: false,
      addstateadmin: false,
      addcityadmin: false,
      addloweradmin: false,
      logofloweradmin: false,
      removecountryadmin: false,
      removecityadmin: false,
      lowerlog: false,
      revertstateadminaction: false,
      mandtyremovepost: false,
      pendingactions: [],
      fields: [
        { key: "action", label: "Type", sortable: true },
        {
          key: "details",
          label: "Details",
          sortable: true,
          class: "text-center",
        },
        {
          key: "pending",
          label: "Pending Since",
          sortable: true,
          class: "text-center",
        },

        { key: "addedby", label: "Added By", sortable: true },
      ],
      activitylogs: [],
      rootlogfields: [
        // { key: "type", label: "Type", sortable: true },
        {
          key: "action",
          label: "Action",
          sortable: true,
          class: "text-center",
        },
        {
          key: "description",
          label: "Details",
          sortable: true,
          class: "text-center",
        },

        {
          key: "createddate",
          label: "Date & Time",
          class: "text-center",
          sortable: true,
        },
        {
          key: "revert",
          label: "Revert",
          sortable: false,
          class: "text-center",
        },
      ],
      logfields: [
        // { key: "type", label: "Type", sortable: true },
        {
          key: "action",
          label: "Action",
          sortable: true,
          class: "text-center",
        },
        {
          key: "description",
          label: "Details",
          sortable: true,
          class: "text-center",
        },

        {
          key: "createddate",
          label: "Date & Time",
          class: "text-center",
          sortable: true,
        },
      ],
      totalpendingactions: 0,
      totalactivitylogs: 0,

      currentpendingactions: 1,
      currentactivitylogs: 1,
      isroot: localStorage.getItem("isroot"),
      perPage: 10,
    };
  },
  mounted() {
    // if (localStorage.getItem("role") != "Sub Admin")
    // this.superAdmin = true;
    this.getData();
    this.getPendingactions(), this.getActivitylog();
  },
  methods: {
    next() {
      // alert(this.id,this.idset)
      var temp = [];
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          this.$router.push("/Cases/" + temp[j + 1] + "/" + temp);
          this.getData();
        }
      }
    },
    previous() {
      var temp = [];
      // console.log("hiil", this.idset);
      temp = this.idset.split(",");

      for (var j = 0; j < temp.length; j++) {
        if (this.id == temp[j]) {
          if (j != 0) {
            this.$router.push("/Cases/" + temp[j - 1] + "/" + temp);
            this.getData();
          }
        }
      }
    },
    nextpending(ev) {
      this.currentpendingactions = ev;
      this.getPendingactions(this.currentUser);
    },
    nextlog(ev) {
      this.currentactivitylogs = ev;
      this.getActivitylog(this.currentUser);
    },
    changeList(item) {
      this.listType = item;
      var url1;
      if (item == "basicinfo") {
        this.bascinfo = true;
        this.rrights = false;
        this.pendingact = false;
        this.actlog = false;
        url1 = "/product/dailyessential/discount";
      } else if (item == "roles") {
        this.bascinfo = false;
        this.rrights = true;
        this.pendingact = false;
        this.actlog = false;
        url1 = "/product/dailyessential/bestseller";
      } else if (item == "pending") {
        this.bascinfo = false;
        this.rrights = false;
        this.pendingact = true;
        this.actlog = false;
        url1 = "/product/dailyessential/newproducts";
      } else if (item == "log") {
        this.bascinfo = false;
        this.rrights = false;
        this.pendingact = false;
        this.actlog = true;
        url1 = "/product/dailyessential/newproducts";
      }
      //   this.getData(url1);
    },
    nextPage(ev) {
      this.currentPage = ev;
      this.getData();
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/info",
        params: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.name = this.user.name;
          this.role = response.data.data.type;

          this.userRights = response.data.userrights;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getPendingactions() {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/user/pendingaction",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          userid: this.$route.params.id,
          count: this.perPage,
          page: this.currentpendingactions,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.countrylist = response.data.data;
          this.totalpendingactions = response.data.totalcount;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    getActivitylog() {
      this.appLoading = true;

      axios({
        method: "GET",
        url: "/user/loweradminactivity",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          userid: this.$route.params.id,
          count: this.perPage,
          page: this.currentactivitylogs,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.activitylogs = response.data.data;
          this.totalactivitylogs = response.data.totalcount;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    confirmDeactivateUser() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to deactivate this user.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.deactivateUser();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    confirmRemoveUser() {
      this.showReason = false;
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to remove this admin?", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "Remove",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.removeUser();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    editUser() {
      this.$dlg.modal(EditUser, {
        width: "",
        height: 500,
        title: "Edit User",
        maxButton: true,
        closeButton: true,
        params: {
          userData: this.user,
        },
        callback: (data) => {
          if (data.update) {
            this.getData();
          }
          if (!data.status) {
            this.ServerError = true;
          }
        },
      });
    },
    deactivateUser() {
      this.appLoading = true;
      var newURL;
      if (this.userStatus == "Banned") {
        // this.userStatus = "Active";
        newURL = "user/activateuser";
      } else if (this.userStatus == "Active") {
        // this.userStatus = "Banned";
        newURL = "user/banuser";
      }
      axios({
        method: "POST",
        // url: "/user/banuser",
        url: newURL,
        data: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getData();
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    removeAdmin() {
      axios({
        method: "POST",
        url: "/user/removeuser",
        data: {
          id: this.$route.params.id,
          reason: this.textReason,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          // this.getData();
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmrevertAction(item) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to revert this action.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "sm",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.revertAction(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },

    revertAction(item) {
      axios({
        method: "POST",
        url: "/user/revertaction",
        data: {
          id: item._id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getActivitylog();
          this.$notify({
            group: "appNotify",
            title: "Save Trees",
            text: response.data.msg,
          });
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>
<style  scoped>
.buttonlink {
  text-decoration: none;
}
</style>